import { produccionRetiroApi } from '../../utils/api';
import { getListDataAction } from '../../utils/DataAction';

export const getAll = getListDataAction({
  dataName: 'DESTINO',
  api: produccionRetiroApi,
  relUrl: 'getAllDestinos',
});
